export const hasTextContent = (html: string | undefined | null): html is string => {
  if (!html) {
    return false
  }

  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = html
  const textContent = tempDiv.textContent || tempDiv.innerText || ''

  return textContent.trim().length > 0
}

/**
 * Opens every link of the rendered HTML in a new tab without handing over `window.opener`, so a
 * contractor following a link from a form step keeps the onboarding tab and their unsubmitted
 * answers. The rest of the markup is kept as is; it is parsed in an inert `<template>`, so nothing
 * in it loads or runs.
 */
export const openLinksInNewTab = (html: string | undefined | null): string => {
  if (!html) {
    return ''
  }

  const template = document.createElement('template')
  template.innerHTML = html

  template.content.querySelectorAll('a').forEach((anchor) => {
    anchor.setAttribute('target', '_blank')
    anchor.setAttribute('rel', 'noopener noreferrer')
  })

  return template.innerHTML
}
